<template>
  <div class="modalnobefore contentClock">
    <div class="align-center mb16">
      <Select class="select" v-model="year" @on-change="changeDate">
        <Option v-for="item in yearList" :value="item" :key="'year' + item">{{ item }}</Option>
      </Select>
      年
      <Select class="select" v-model="month" @on-change="changeDate">
        <Option v-for="item in monthList" :value="item" :key="'month' + item">{{ item }}</Option>
      </Select>
      月
    </div>
    <div class="schedule">
      <div class="weeks title-w">
        <div class="week-item" v-for="item in weeks" :key="item">{{ item }}</div>
      </div>
      <div class="date" v-for="(item, index) in pageData" :key="'page' + index">
        <template v-for="(item1, indexx) in item">
          <div
              :class="['date-item', { blank: item1 == 0, 'btn-primary111': item1.checked }]"
              v-if="item.length > 0"
              @click.stop="clickDate(item1)"
              :key="indexx"
          >
            <div class="align-right">{{ item1 !== 0 ? item1.scheduleDate : '' }}</div>
            <div v-for="(item2, index2) in item1.scheduleList" :key="'keyB' + index2">
              <div style="height:25px;line-height:25px">
                <img
                    :src="
                    item2.amAttendanceResult == '旷工'
                      ? queqin
                      : item2.amAttendanceResult == '迟到'
                      ? late
                      : ban
                  "
                    style="vertical-align: top;margin-right: 6px; margin-top: 4px;"
                />
                <span
                    :style="{
                    color:
                      item2.amAttendanceResult == '旷工'
                        ? 'rgb(219,52,52)'
                        : item2.amAttendanceResult == '迟到'
                        ? '#ffa000'
                        : 'rgb(13,149,74)',
                  }"
                >{{ item2.amAttendanceResult != '' ? item2.amAttendanceResult : '' }}</span
                >
                <span style="margin-left:7px">{{
                    item2.amClockTime && item2.amClockTime != ''
                        ? '  上午：' + item2.amClockTime
                        : ''
                  }}</span>
              </div>
              <div style="height:25px;line-height:25px">
                <img
                    :src="
                    item2.pmAttendanceResult == '旷工'
                      ? queqin
                      : item2.pmAttendanceResult == '迟到' || item2.pmAttendanceResult == '早退'
                      ? late
                      : ban
                  "
                    style="vertical-align: top;margin-right: 6px; margin-top: 4px;"
                />
                <span
                    :style="{
                    color:
                      item2.pmAttendanceResult == '旷工'
                        ? 'rgb(219,52,52)'
                        : item2.pmAttendanceResult == '迟到' || item2.pmAttendanceResult == '早退'
                        ? '#ffa000'
                        : 'rgb(13,149,74)',
                  }"
                >{{ item2.pmAttendanceResult != '' ? item2.pmAttendanceResult : '' }}</span
                >
                <span style="margin-left:7px">{{
                    item2.pmClockTime && item2.pmClockTime != ''
                        ? '  下午：' + item2.pmClockTime
                        : ''
                  }}</span>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { getClockinRecord } from '../../api/clockin';
import { deepClone } from '../../utils/format';
import ban from '@/assets/ban.png';
import queqin from '@/assets/queqin.png';
import late from '@/assets/late.png';

export default {
  name: 'schedule1',
  components: {
    // PaiBanModal
  },
  data() {
    return {
      weeks: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      year: '',
      yearList: [],
      month: '',
      monthList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      dataList: [],
      n: 0,
      projectFid: '',
      today: '',
      zos: [],
      scheduleConfig: [],
      projectName: '',
      projectList: [],
      personCode: this.$route.query.id,
      ban: ban,
      late: late,
      queqin: queqin,
    };
  },
  computed: {
    checkedData() {
      return this.dataList.filter((ele) => {
        return ele['checked'];
      });
    },
    pageData() {
      if (this.dataList.length == 0) {
        return;
      }
      var firstday = new Date(this.year, this.month - 1, 1);
      var index = firstday.getDay();
      var beforeAdd = Array(index).fill(0);
      this.dataList = beforeAdd.concat(this.dataList);
      return [
        this.dataList.slice(0, 7),
        this.dataList.slice(7, 14),
        this.dataList.slice(14, 21),
        this.dataList.slice(21, 28),
        this.fillEnd(this.dataList.slice(28, 35)),
        this.fillEnd(this.dataList.slice(35)),
      ];
    },
    // dataList
  },
  methods: {
    changeDate() {
      this.getDataList();
    },
    makeDate(date) {
      let month = (this.month + '').length >= 2 ? this.month : '0' + this.month;
      let date1 = (date + '').length >= 2 ? date : '0' + date;
      return this.year + '-' + month + '-' + date1;
    },
    makeScheduleDateList(list) {
      var ret = [];
      this.checkedData.forEach((ele) => {
        ret.push({
          scheduleDate: this.makeDate(ele.scheduleDate),
          scheduleList: list,
        });
      });
      return ret;
    },
    addAddition(list) {
      var ret = deepClone(list);

      this.scheduleConfig.forEach((ele) => {
        let ishas = false;
        list.forEach((ele1) => {
          if (ele.scheduleConfigFid == ele1.scheduleConfigFid) {
            ishas = true;
          }
        });
        !ishas && ret.push(ele);
      });

      //去除历史排班信息
      ret = ret.filter((ele) => {
        var isDead = true;
        this.scheduleConfig.forEach((ele1) => {
          if (ele.scheduleConfigFid == ele1.scheduleConfigFid) {
            isDead = false;
          }
        });
        return !isDead;
      });
      return ret;
    },

    projectChange() {
      this.getDataList();
    },
    getDataList() {
      var params = {
        personCode: this.personCode,
        scheduleDate: this.year + '-' + (this.month < 10 ? '0' + this.month : this.month),
      };
      getClockinRecord(params).then((res) => {
        this.addCheckTag(res.data);
        this.dataList = res.data;
      });
    },
    format(value) {
      return value.toString().length > 1 ? value : '0' + value;
    },
    initYM() {
      var today = new Date();
      var year = today.getFullYear();
      var month = today.getMonth() + 1;
      var day = today.getDate();
      this.month = month;
      this.year = year;
      this.yearList = [year - 1, year, year + 1, year + 2, year + 3, year + 4, year + 5];
      this.today = '' + year + this.format(month) + this.format(day);
    },
    doSchedule() {
      if (!this.projectFid) {
        this.$Message.info('请选择项目');
        return;
      }
      if (this.scheduleConfig.length == 0) {
        this.$Message.info('请先设置班次信息');
        return;
      }
      if (!this.checkedData || this.checkedData.length == 0) {
        this.$Message.info('请选择日期');
        return;
      }
      this.n++;
    },
    fillEnd(arr) {
      if (arr.length == 0) {
        return arr;
      }
      return arr.concat(Array(7 - arr.length).fill(0));
    },
    clickDate(item) {},
    addCheckTag(list) {
      list.forEach((ele) => {
        if (ele == 0) {
          return;
        }
        ele['checked'] = false;
        ele.scheduleList &&
        ele.scheduleList.forEach((ele1) => {
          ele1['checked'] = false;
        });
      });
    },
  },
  created() {
    this.initYM();
    this.getDataList();
  },
};
</script>
<style scoped lang="less">
.contentClock {
  padding: 20px 50px;
}
.align-right {
  text-align: right;
}

.select-width {
  width: 200px;
}

.schedule {
  font-weight: bold;
  position: relative;
  .title-w {
    background: #eee !important;
    .week-item {
      // background-color: #f9f9f9;
      flex: auto;
      line-height: 2.8;
      text-align: center;
      box-sizing: border-box;
      border: 1px solid #dddddd;
      border-bottom: none;
      margin-left: -1px;
      color: #666;
    }
  }
}

.no-data {
  text-align: center;
  height: 60px;
  line-height: 60px;
  border: 1px solid rgb(210, 210, 210);
}

.doSchedule {
  margin-left: 60px;
}

.date-item {
  padding: 10px;
  height: 90px;
  /*background-color: rgb(240, 240, 240);*/
  box-sizing: border-box;
  flex: 1;
  border: 1px solid #dddddd;
  overflow: auto;
  margin-top: -1px;
  margin-left: -1px;
  background: #f8f8f8;
  font-weight: normal;
}
.date-item:first-child {
  margin-left: 0px;
}

.weeks,
.date {
  display: flex;
  /*background-color: rgb(240,240,240);*/
}

.blank {
  background-color: rgb(255, 255, 255);
}

.week-item:first-child {
  margin-left: 0px;
}

.select {
  margin: 0 10px;
  width: 100px;
  display: inline-block;
}

.align-center {
  text-align: center;
  margin-top: 10px;
}
.btn-primary111 {
  border: 1px solid #cfa868;
  z-index: 999;
}
</style>
